import { createElement } from 'react'
import fp from 'lodash/fp'
import { Table } from 'shared/components'

import { TournamentLogoCell } from './components/tournamentLogoCell'
import { TeamCell } from './components/teamCell'
import { InWinCell } from './components/inWinButtonCell'

export const createColumns = () => [
  {
    Header: 'Tournament',
    id: 'matchName',
    accessor: fp.identity,
    Cell: TournamentLogoCell,
    minWidth: 120,
  },
  {
    Header: 'Event',
    id: 'event',
    accessor: (row) => {
      // Detect custom event by checking if teamOne and teamTwo are missing
      // or if teamA and teamB are empty strings
      const isCustomEvent = (
        (!row.teamOne && !row.teamTwo) ||
        ((!row.teamA || row.teamA === '') && (!row.teamB || row.teamB === ''))
      );

      if (isCustomEvent) {
        // For custom events, return the event object with a flag
        return {
          isCustomEvent: true,
          event: row
        }
      }

      // For regular events with teams, return both teams
      return {
        isCustomEvent: false,
        teamA: row.teamA,
        teamB: row.teamB,
        teamOneObj: row.teamOne,
        teamTwoObj: row.teamTwo
      }
    },
    Cell: TeamCell,
    minWidth: 450, // Wide enough for two teams
  },
  {
    Header: 'Date',
    accessor: 'startTime',
    Cell: Table.CellRenderers.DateCell,
    minWidth: 176,
  },
  {
    Header: 'Time',
    accessor: 'startTime',
    Cell: Table.CellRenderers.TimeCell,
    minWidth: 176,
  },
  {
    Header: 'InWin',
    id: 'InWin',
    accessor: fp.identity,
    Cell: (props) => createElement(InWinCell, { ...props }),
  },
]
